<article class="unauthorized-page">
  <div class="page-container">
    <div class="page-message-container">
      <div class="page-message">
        <h1>
          404!
        </h1>
        <p>
          Sorry, the resource you are looking for <br />
          cannot be found.
        </p>
        <div class="page-message-buttons">
          <button mat-flat-button color="primary" (click)="back()" *ngIf="showBackButton">
            Back
          </button>
        </div>
      </div>
      <div class="page-message-message-icon">
        <img src="assets/images/icons/not-found-cloud.svg" alt="401 image" width="128" height="128" />
      </div>
    </div>
  </div>
</article>
